import { Button, Result, Row } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "./MainLayout";
import { Utils } from "../Utilities/Utils";

const PageNotFound = () => {
  const navigate = useNavigate();
  const userToken = Utils.getLocal('ActingOffice.Admin.Token');

  // console.log("token", userToken);

  React.useEffect(() => {
    if (!userToken?.token) {
      navigate("/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  return (
    <>
      <Row justify="start" align="middle" style={{ margin: "1px 15px" }}>
        <PageHeader
          item={[
            {
              label: "Page Not Found",
            },
          ]}
          style={{ color: "#172B4D" }}
        />
      </Row>
      <Row
        className="p-3"
        style={{
          backgroundColor: "white",
          height: "100%",
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          flexFlow: "column",
        }}
      >
        <Result
          status="404"
          // title="404"
          subTitle="Sorry, the page you visited does not exist."
          extra={
            <Button onClick={() => navigate(-1)} type="primary">
              Back
            </Button>
          }
        />
      </Row>
    </>
  );
};
export default PageNotFound;
